import { RouterOutputs, trpc } from "../trpc";

export type StorageZap = RouterOutputs["zap"]["storageZaps"][string];

interface Return {
  response: Record<string, StorageZap>;
  isFetching: boolean;
  isLoading: boolean;
}

interface Input {
  ids: number[];
  enabled?: boolean;
}

export function useQueryStorageZaps({ ids, enabled = true }: Input): Return {
  const { data, isFetching, isLoading } = trpc.zap.storageZaps.useQuery(
    { ids },
    { enabled: ids.length > 0 && enabled },
  );

  return {
    response: data || ({} as Record<string, StorageZap>),
    isFetching,
    isLoading,
  };
}
